import { Layer } from 'dashboard/components/GraphCanvasV2/layers/layer';
import WindowTarget from 'dashboard/components/GraphCanvasV2/target/window-target';

export default class WindowLayer extends Layer implements Iterable<WindowTarget> {
  public [Symbol.iterator](): Iterator<WindowTarget, null> {
    const els = [window];

    return {
      next: function () {
        const value = els.shift();

        const result: IteratorResult<WindowTarget, null> = value
          ? {
              value: new WindowTarget(value),
              done: false,
            }
          : {
              value: null,
              done: true,
            };

        return result;
      }.bind(this),
    };
  }
}
